import { request } from "../utils/request.js"


export const commodityCategory_addNew = (pojo, args) => request({
    url: 'commodityCategory/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityCategory_update = (pojo, args) => request({
    url: 'commodityCategory/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityCategory_findByPage = (pojo, args) => request({
    url: 'commodityCategory/findByPage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityCategory_findPageForSelect = (pojo, args) => request({
    url: 'commodityCategory/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityCategory_findAvailableList = (args) => request({
    url: 'commodityCategory/findAvailableList',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const commodityCategory_findById = (id, args) => request({
    url: 'commodityCategory/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const commodityCategory_changeFrozenStatus = (id, args) => request({
    url: 'commodityCategory/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/commodityCategory.js